import { BySellerRowItem, VolumeAndRates } from "../../types/seller.types";
import { transformResultCommonFieldsToTableRow } from "./CommonTableRowTransformer";
import { ByCustomerOrVolume } from "@/features/statistics/types/ByCustomerOrVolumeEnum";
import { StatisticsResultListItem } from "@/features/statistics/config/ResultTableConfig";

export const transformResultToTableRow = (
  row: BySellerRowItem,
  volumeAndRates: VolumeAndRates,
  checkedRadioButton: ByCustomerOrVolume
): StatisticsResultListItem => {
  const volumeAndTargetForSelected = volumeAndRates.find(
    (v) => v.seller.id === row.seller.id
  )?.volumeAndTargetForSelected;

  return {
    ownerName: row.seller.name,
    ownerId: row.seller.id,
    ...transformResultCommonFieldsToTableRow(row, checkedRadioButton),
    ...{
      ...volumeAndTargetForSelected,
    },
  };
};
